export * from './src/scan.component';
export * from './src/scan-dialog.service';
